export const START_OPTIONS_REQUEST = 'START_OPTIONS_REQUEST';
export const STOP_OPTIONS_REQUEST = 'STOP_OPTIONS_REQUEST';

export const START_SUB_OPTIONS_REQUEST = 'START_SUB_OPTIONS_REQUEST';
export const STOP_SUB_OPTIONS_REQUEST = 'STOP_SUB_OPTIONS_REQUEST';

export const SET_API_OPTIONS = 'SET_API_OPTIONS';
export const RESET_API_OPTIONS = 'RESET_API_OPTIONS';
